import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { customElement, property } from 'lit/decorators.js'
import { LitElement } from 'lit'
import { AssignableButton } from '../../app-core/lib/user/AssignableButton'

type componentProps = React.ComponentProps<typeof AssignableButton>

export enum Events {
    onClick = 'on-click',
}

export interface CustomEvents {
    [Events.onClick]: CustomEvent<['on-click']>
}

@customElement('zaptic-assignable-button')
export class ZapticAssignableButton extends LitElement {
    @property({ type: Object })
    props: componentProps

    private onClick() {
        this.dispatchEvent(new CustomEvent(Events.onClick, {}))
    }

    render() {
        return ReactDOM.render(<AssignableButton {...this.props} onClick={this.onClick} />, this)
    }

    protected createRenderRoot() {
        return this
    }
}
